var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 552,
    viewBox: "0 0 1440 552",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5765_67449",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 552
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 552,
    transform: "matrix(1 0 0 -1 0 552)",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5765_67449)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M653.139 -1069.98C665.76 -1094.54 695.903 -1104.22 720.464 -1091.6L1998.45 -434.856C2023.01 -422.234 2032.69 -392.092 2020.06 -367.531L1546.48 554.03C1533.86 578.587 1503.92 588.368 1479.37 575.753C1365.5 517.268 1056.31 358.439 840.648 247.511C625.49 136.841 315.161 -22.5718 201.005 -81.2067C176.438 -93.8257 166.946 -123.875 179.569 -148.44L653.139 -1069.98Z",
    fill: "#EBFCEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-290.89 304.471C-278.268 279.91 -248.125 270.232 -223.564 282.855L1150.89 989.227C1175.45 1001.85 1185.12 1031.99 1172.5 1056.55L807.261 1767.24C794.64 1791.79 764.598 1801.52 740.039 1788.9C620.678 1727.58 286.05 1555.66 53.2218 1435.92C-179.061 1316.46 -514.924 1143.9 -634.588 1082.42C-659.154 1069.8 -668.748 1039.7 -656.124 1015.14L-290.89 304.471Z",
    fill: "url(#paint0_linear_5765_67449)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5765_67449",
    x1: 885.499,
    y1: 1347,
    x2: 29.499,
    y2: 368.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F2FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F2FD",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F2FD",
    stopOpacity: 0.096144
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg4);
export default __webpack_public_path__ + "static/media/bg-4.6a04ae12a1a626bfee440204cf9a7bb0.svg";
export { ForwardRef as ReactComponent };